<template>
  <v-layout>
    <v-flex>
      <div class="text-right mb-6">

        <v-btn
          class="ml-md-10"
          dark
          large
          depressed
          color="primary"
          :to="{ name:'invoice', params: { id: 'add' } }"
        >
          <v-icon dark class="mr-2">
            mdi-plus
          </v-icon>
          <span class="mx-4">Create New Invoice</span>
        </v-btn>
      </div>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Invoices
          <v-spacer></v-spacer>
          <v-select
            v-model="status"
            :items="statuses"
            @change="filterBy"
            menu-props="auto"
            label="Status"
            item-text="name"
            class="max-width-300 mr-10"
            prepend-icon="mdi-filter-outline"
            item-value="id"
            hide-details
          >
          </v-select>
          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="invoices"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Invoices..."
          item-key="id"
          no-data-text="No Invoices Found"
          :options.sync="options"
          :item-class="itemRowBackground"
          ref="table">

          <template v-slot:[`item.grand_total`]="{ item }">
            {{ formatNumberAmount($numeral, item.grand_total) }}
          </template>

          <template v-slot:[`item.invoice_no`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-2">
                mdi-receipt-text-check
              </v-icon>
              {{ item.invoice_no }}
            </div>
          </template>

          <template v-slot:[`item.containers`]="{ item }">
            {{ item.containers }}
          </template>

          <template v-slot:[`item.sales_agent_name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-face-agent
              </v-icon>

              {{ item.sales_agent_name }}
            </div>
          </template>

          <template v-slot:[`item.bill_to_name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-2">
                mdi-account-outline
              </v-icon>
              {{ item.bill_to_name }}
            </div>
          </template>

          <template v-slot:[`item.has_proof_of_payment`]="{ item }">
            <v-icon
              v-if="item.has_proof_of_payment == 1"
              size="24"
              color="red darken-2"
              class="mr-2">
              mdi-check-decagram
            </v-icon>
          </template>


          <template v-slot:[`item.status`]="{ item }">
            <InvoiceStatus :status="item.status" :small="true" :statuses="statuses"></InvoiceStatus>
          </template>

          <template v-slot:[`item.invoice_date`]="{ item }">
            {{ item.invoice_date | moment("MMM D, YYYY") }}
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:[`item.due_date`]="{ item }">
            {{ item.due_date | moment("MMM D, YYYY") }}
          </template>

          <template v-slot:[`item.points_redeemed`]="{ item }">
            {{ formatNumberAmount($numeral, item.points_redeemed) }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-menu
              transition="slide-y-transition"
              offset-y
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item link @click="viewItem(item.id)">
                  <v-list-item-title><v-icon class="mr-4">
                      mdi-file-document-outline
                    </v-icon>
                    View
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="sendInvoice(item)" v-if="item.status == $getConstInvoiceStatus('INVOICE_STATUS_CREATED')">
                  <v-list-item-title><v-icon class="mr-4">
                      mdi-receipt-text-send-outline
                    </v-icon>
                    Send Invoice
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="editItem(item.id)" v-if="item.status != $getConstInvoiceStatus('INVOICE_STATUS_PAID')">
                  <v-list-item-title>
                    <v-icon class="mr-4">
                      mdi-receipt-text-edit-outline
                    </v-icon>
                    Edit
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="paymentMade(item)" v-if="item.status == $getConstInvoiceStatus('INVOICE_STATUS_SENT')">
                  <v-list-item-title><v-icon class="mr-4">
                      mdi-receipt-text-send-outline
                    </v-icon>
                    Payment Made
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="deleteItem(item)" v-if="item.status == $getConstInvoiceStatus('INVOICE_STATUS_CREATED')">
                  <v-list-item-title>
                    <v-icon class="mr-4">
                      mdi-receipt-text-remove-outline
                    </v-icon>
                    Delete
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <!-- <template v-slot:item.action="{ item }">

            <v-tooltip bottom v-if="item.status != $getConstInvoiceStatus('INVOICE_STATUS_CREATED')">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  class="mr-2"
                  @click="viewItem(item.id)">
                  mdi-file-document
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.status == $getConstInvoiceStatus('INVOICE_STATUS_CREATED')">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="mr-2"
                  color="red darken-2"
                  @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.status == $getConstInvoiceStatus('INVOICE_STATUS_CREATED')">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  @click="editItem(item.id)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>


          </template> -->
        </v-data-table>
      </v-card>




      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
    </v-flex>
  </v-layout>

</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import InvoiceStatus from '@/components/InvoiceStatus.vue'

  export default {
    name: 'AgentBookingList',
    data() {
      return {
        accountingNamespace: 'accounting',
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        dialog: {
          show: false,
          title: 'Delete Item',
          body: 'Are you sure you want to delete this item?',
          type: '',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        status: '',
        statuses: [],
        invoices: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Invoice No.',
            align: 'start',
            value: 'invoice_no',
            sortable: false,
          },
          {
            text: 'Container No.',
            align: 'start',
            value: 'containers',
            sortable: false
          },
          {
            text: 'Shipping Mark',
            align: 'start',
            value: 'shipping_marks',
            sortable: false
          },
          {
            text: 'Sales Agent',
            align: 'start',
            value: 'sales_agent_name',
            sortable: false
          },          
          {
            text: 'Ref. No.',
            align: 'start',
            value: 'ref_no',
            sortable: false
          },
          {
            text: 'Bill To',
            align: 'start',
            value: 'bill_to_name',
            sortable: false
          },
          {
            text: 'Invoice Date',
            align: 'start',
            value: 'invoice_date',
            width: 130,
            sortable: false
          },
          {
            text: 'Due Date',
            align: 'start',
            value: 'due_date',
            width: 130,
            sortable: false
          },
          {
            text: 'Points Redeemed',
            align: 'right',
            value: 'points_redeemed',
            sortable: false
          },
          {
            text: 'Amount',
            align: 'right',
            value: 'grand_total',
            sortable: false
          },
          {
            text: 'Proof of Payment',
            align: 'center',
            value: 'has_proof_of_payment',
            sortable: false
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
            sortable: false,
            width: 120,
          },
          {
            text: '',
            value: 'action',
            sortable: false,
            width: 50
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumber', 'formatNumberAmount']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getInvoices()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getInvoices()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      filterBy (id) {
        this.status = id
        this.options.page = 1
        this.getInvoices()
      },
      itemRowBackground: function (item) {
         return (item.dued == 1 && item.status != this.$getConstInvoiceStatus('INVOICE_STATUS_PAID')) ? 'red lighten-4' : ''
      },
      sendInvoice (invoice){
        this.dialog = {
          show: true,
          title: 'Send Invoice',
          body: 'Are you sure you want to send invoice '+invoice.invoice_no+'?',
          type: 'confirm-send',
          item: invoice,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      doSend(){
        self.loading = true
        this.$http.secured.post(this.accountingNamespace+'/invoices/send/'+this.dialog.item.id, '')
          .then(response => {
            this.showMessage("Invoice "+this.dialog.item.id.invoice_no+" has been successfully sent")
            this.firstLoad = true
            this.getInvoices()
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages, 'error')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      paymentMade (invoice){
        this.dialog = {
          show: true,
          title: 'Invoice Paid',
          body: 'Are you sure payment has been made for invoice '+invoice.invoice_no+'?',
          type: 'confirm-payment',
          item: invoice,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      paid (){
        self.loading = true

        this.$http.secured.post(this.accountingNamespace+'/invoices/paid/'+this.dialog.item.id, '')
          .then(response => {
            this.showMessage("Payment has been posted.", 'success')
            this.firstLoad = true
            this.getInvoices()
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages, 'error')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      editItem (id) {
        this.$router.push({ name: 'invoice', params: { id: id } })
      },
      getAgentName: function(id){
        let agents = this.agents.filter(agent => {
          return agent.id == id
        })
        if(agents.length > 0){
          let agent = agents[0]
          return agent.first_name + ' ' + agent.last_name
        }
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?invoice_statuses=true')
          .then(response => {
            let allowedStatuses = [
              '',
              this.$getConstInvoiceStatus('INVOICE_STATUS_CREATED'),
              this.$getConstInvoiceStatus('INVOICE_STATUS_SENT'),
              this.$getConstInvoiceStatus('INVOICE_STATUS_PAID')
            ]

            response.data.invoice_statuses.forEach(obj => {
              if(allowedStatuses.includes(obj.id)) this.statuses.push(obj)
            })
          })
          .catch(error => {
            console.log(error);
          })
      },
      doConfirm () {
        this.dialog.show = false
        if(this.dialog.type == 'confirm-payment'){
          this.paid()
        }else if(this.dialog.type == 'confirm-send'){
          this.doSend()
        }else{
          this.confirmDeleteItem()
        }
      },
      doCancel () {
        this.dialog.show = false
      },
      deleteItem (item) {
        this.dialog = {
         show: true,
         title: 'Delete Invoice',
         body: 'Are you sure you want to delete '+item.invoice_no+' invoice?',
         type: 'close',
         item: item,
         confirmBtn: 'Yes',
         cancelBtn: 'No'
        }
      },
      confirmDeleteItem () {
        let self = this

        this.$http.secured.delete(this.accountingNamespace+'/invoices/'+ this.dialog.item.id)
          .then(response => {
            this.showMessage(this.dialog.item.invoice_no + " has been successfully deleted", 'success')
            if(this.options.page > 1) {
                this.options.page = 1
            }
            this.getInvoices()
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.error, 'error')
              this.error.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })

      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      viewItem (id) {
        this.$router.push({ name: 'invoice-view', params: { id: id } })
      },
      getInvoices () {

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        params = { page: page, per_page: itemsPerPage }
        if (this.search.length > 0) params.search = this.search
        if (this.status.length > 0) params.status = this.status

        if(this.firstLoad){
          this.$router.push({ name: 'invoices-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get(this.accountingNamespace+'/invoices', { params: params })
          .then(response => {
            this.invoices = response.data.invoices

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.query.added){
        this.showMessage(this.$route.query.message, 'success')
        this.$router.push({ name: 'invoices' })
      }

      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      if(this.$route.query.status){
        this.status = this.$route.query.status
      }

      this.getDefaultData()

    },
    components: {
      SnackBar,
      ConfirmationDialog,
      InvoiceStatus
    },
  }
</script>
